import * as React from "react"

function SvgMenu(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 6 25" fill="none" {...props}>
      <ellipse cx={2.769} cy={2.85} rx={2.769} ry={2.85} fill="#fff" />
      <ellipse cx={2.769} cy={12.349} rx={2.769} ry={2.85} fill="#fff" />
      <ellipse cx={2.769} cy={21.848} rx={2.769} ry={2.85} fill="#fff" />
    </svg>
  )
}

export default SvgMenu

